import VideoPlayerGlobal from './VideoPlayerGlobal';

export default VideoPlayerGlobal;
